module.exports = __webpack_public_path__ + "img/winerackdog45.de46de9e.jpg";